import React from "react";
import { Icons } from "../../atoms/Icons";
import "./includeotherretirement.scss";
import { Card, Col, Row } from "react-bootstrap";
import Buttons from "../../atoms/Buttons";
import { addCommas } from "../../helpers/helpers";
import { useNavigate } from "react-router-dom";
import { ModalOverlay } from "../../atoms/Modal";
const IncludeOtherRetirementModal = (props) => {
  const navigate = useNavigate();
  const formattedDecimal = Number(props.tptTotalPot).toFixed(2);
  return (
    <div className="include-other-pension-modal-container">
      <div className="include-other-pension-close">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <p className="title text-center">{props.modalTitle}</p>
      <p className="text-center description">{props.description}</p>
      <Row className="mt-5 g-2">
        <Col sm={12} md={4} lg={4}>
          <Card>
            <p className="headings">TPT pot</p>
            <p className="ior-value">£{addCommas(formattedDecimal)}</p>
          </Card>
        </Col>
        <Col sm={12} md={8} lg={8}>
          <Row className="g-2">
            <Col sm={12} md={6} lg={6}>
              <Card className="ior-linked-pension">
                <p className="headings">Connected pension</p>
                <p className="ior-value">
                  {parseFloat(props.linkedPensionValue) === 0 ? (
                    "No connected pensions"
                  ) : (
                    <>
                      £{addCommas(props.linkedPensionValue?.split(".")[0])}
                      {props.linkedPensionValue?.split(".")[1] > 0 ? (
                        <span>.{props.linkedPensionValue?.split(".")[1]}</span>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </p>
                <Buttons
                  name="Take me to connected pension"
                  className="tertiary text-end mt-3"
                  handleClick={() => navigate("/manage?tab=otherPots")}
                />
              </Card>
            </Col>
            <Col sm={12} md={6} lg={6} className="order-1-xs-3">
              <Card>
                <p className="headings">Add other retirement savings</p>
                <p className="ior-value mb-2">
                  £{addCommas(props.expectedSavingsIncome)}
                </p>
                <div className="text-end">
                  <Icons
                    iconname="add"
                    variant="icon-twenty-four-px"
                    clickHandler={() => props.setOtherRetirementModal(true)}
                  />
                </div>
              </Card>
            </Col>
            <Col sm={12} md={6} lg={6}>
              <Card>
                <p className="headings">State pension</p>
                <p className="ior-value">
                  {addCommas(props.statePensionValue).split(".")[0]} /year
                </p>
              </Card>
            </Col>
            <Col sm={12} md={6} lg={6} className="order-1-xs-4">
              <Card>
                <p className="headings">Add other income (DB)</p>
                <p className="ior-value mb-2">
                  £{addCommas(props.dBEstIncome)} /year
                </p>
                <div className="text-end">
                  <Icons
                    iconname="add"
                    variant="icon-twenty-four-px"
                    clickHandler={() => {
                      props.setOtherIncomeDBModal(true);
                    }}
                  />
                </div>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col xs={12} className="text-end">
          <Buttons
            name="Done"
            className="primary"
            handleClick={props.btnDoneHandler}
          />
        </Col>
      </Row>
      {/* Other retirement savings modal */}
      <ModalOverlay
        popup="otherRetirementSavingsDB"
        show={props.otherRetirementModal}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          props.setOtherRetirementModal(false);
        }}
        otherRetirementModal={props.otherRetirementModal}
        expectedSavingsIncome={props.expectedSavingsIncome}
        setExpectedSavingsIncome={props.setExpectedSavingsIncome}
        subHeading="Add other retirement savings"
        subDescription="Add the estimated value of all your old pensions and any other savings that you have earmarked for retirement, not including any TPT pensions."
        modalTitle="Include other pensions in your forecast"
        description="Adding other pensions can help get a more holistic look at what life may be like in retirement."
        setOtherRetirementModal={props.setOtherRetirementModal}
        btnBackHandler={() => {
          props.setOtherRetirementModal(false);
        }}
      />
      {/* Other Income DB modal */}
      <ModalOverlay
        popup="otherRetirementSavingsDB"
        show={props.otherIncomeDBModal}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          props.setOtherIncomeDBModal(false);
        }}
        otherIncomeDBModal={props.otherIncomeDBModal}
        modalTitle="Include other pensions in your forecast"
        description="Adding other pensions can help get a more holistic look at what life may be like in retirement."
        subHeading="Add other income (DB)"
        subDescription="Add any income that you expect to receive in retirement here and an age that it would become payable."
        dBEstIncome={props.dBEstIncome}
        setDBEstIncome={props.setDBEstIncome}
        otherIncomeDBAge={props.otherIncomeDBAge}
        setOtherIncomeDBAge={props.setOtherIncomeDBAge}
        setOtherIncomeDBModal={props.setOtherIncomeDBModal}
        btnBackHandler={() => {
          props.setOtherIncomeDBModal(false);
        }}
        membershipType={props.membershipType}
      />
    </div>
  );
};

export default IncludeOtherRetirementModal;
